import React from 'react';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import { Theme } from '../types';

const ReturnHomeButton = () => (
	<Button component={Link} to='/' variant='contained' startIcon={<HomeIcon />} sx={{ mt: 1, '&:visited': { color: (theme) => (theme as Theme).palette.primary.contrastText}, }}>
		Return to home page
	</Button>
);

export default ReturnHomeButton;
